<template>
  <div>
    <el-dialog
      class="dialog"
      title="添加素材"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose1"
    >
      <!-- 库列表 -->
      <ul class="clearfix box">
        <li
          class="box_li"
          v-for="(item, index) in list"
          :key="index"
          :class="{ active: index == resActive }"
          @click="handlechange(item)"
        >
          {{ item.name }}
        </li>
        <li class="fr" style="margin-right: 10px">
          <el-button type="danger" @click="handledialog">本地上传</el-button>
        </li>
      </ul>
      <!-- 本地上传 弹框 -->

      <el-dialog
        title="本地上传素材"
        :visible.sync="dialogFormVisible"
        width="30%"
        append-to-body
      >
        <el-form :model="form">
          <el-form-item label="素材类型：" style="margin-top: 20px">
            <el-select
              style="width: 20%"
              v-model="addfiledata.title_list_list"
              @change="choserestype"
            >
              <el-option
                v-for="item in title_list"
                :key="item.restype_id"
                :label="item.restype_name"
                :value="item.restype_id"
              >
              </el-option>
            </el-select>

            <span style="margin-left: 30px">素材格式：</span>

            <el-select
              style="width: 24%"
              v-model="addfiledata.formatypearr_list"
              @change="chosefmttype"
            >
              <el-option
                v-for="item in formatypearr"
                :key="item.fmttype_id"
                :label="item.fmttype_name"
                :value="item.fmttype_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择素材：" style="margin-top: 20px">
            <el-upload
              action="https://test.rujiaowang.net/api/resource/get_oss_key"
              :on-change="handleChange"
              :show-file-list="true"
              :file-list="fileList"
              :limit="1"
              :before-upload="beforeUpload"
            >
              <el-button type="primary">本地上传</el-button>
              <span slot="tip" class="el-upload__tip">注意：单个文件上传 </span>
            </el-upload>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleAddfile">确 定</el-button>
        </div>
      </el-dialog>
      <!-- <el-divider></el-divider> -->
      <!-- 类型 -->
      <div class="clearfix posi">
        <span class="list_span">{{ type_name.type1 }}:</span>
        <ul
          class="type-content typelist clearfix"
          :class="{ typelisthei: fixedcheck == true }"
        >
          <li
            v-for="(item, index) in resourlist"
            :key="index"
            :class="{ active1: item.type_id == devActive }"
            @click="restypechange(item.type_id)"
          >
            {{ item.type_name }}
          </li>
        </ul>
      </div>
      <!-- <el-divider></el-divider> -->
      <!-- 题型 -->
      <div class="clearfix posi">
        <span class="list_span">{{ type_name.type2 }}:</span>
        <ul class="type-content">
          <li
            v-for="item in formatypearr"
            :key="item.fmttype_id"
            :class="{ active1: item.fmttype_id == fmtActive }"
            @click="fmttype(item.fmttype_id)"
          >
            {{ item.fmttype_name }}
          </li>
        </ul>
      </div>

      <!-- 搜索 -->
      <div class="sort_content clearfix">
        <ul class="clearfix search fl">
          <li :class="{ sort_active: shows == 'up' }" @click="scShow()">
            {{ sort_name.sort1 }}
          </li>
          <li :class="{ sort_active: shows == 'down' }" @click="xzShow()">
            {{ sort_name.sort2 }}
          </li>
          <li :class="{ sort_active: shows == 'score' }" @click="pfShow()">
            {{ sort_name.sort3 }}
          </li>
          <li>
            <div class="ziyuan fr">
              <span class="zy_span"
                >共<span class="zynumber">{{ Number(listconhttpnum) }}</span
                >条资源</span
              >
            </div>
          </li>
          <li>
            <el-input
              size="mini"
              v-model="input"
              placeholder="请输入关键字"
              @change="subchange(input)"
              background-color="red"
            >
              <div slot="suffix">
                <i class="el-input__icon el-icon-search"></i>
              </div>
            </el-input>
          </li>
        </ul>
      </div>

      <!-- 课件列表 -->
      <div class="zanwuicon" v-if="listconhttpnum == 0">
        <svg aria-hidden="true">
          <use xlink:href="#iconkejian"></use>
        </svg>
        <span>暂无资源</span>
      </div>
      <ul class="st_list">
        <li
          v-for="(item, index) in arr"
          :key="index"
          :class="{ listactive: listact == index }"
          @click="handleClick(item, index)"
        >
          <div class="clearfix">
            <svg
              class="icon fl"
              aria-hidden="true"
              v-if="
                item.file_name.substring(item.file_name.length - 3) == 'ppt'
              "
            >
              <use xlink:href="#iconppt"></use>
            </svg>
            <svg
              class="icon fl"
              aria-hidden="true"
              v-if="
                item.file_name.substring(item.file_name.length - 3) == 'ptx'
              "
            >
              <use xlink:href="#iconppt"></use>
            </svg>
            <svg
              class="icon fl"
              aria-hidden="true"
              v-if="
                item.file_name.substring(item.file_name.length - 3) == 'doc'
              "
            >
              <use xlink:href="#iconword"></use>
            </svg>
            <svg
              class="icon fl"
              aria-hidden="true"
              v-if="
                item.file_name.substring(item.file_name.length - 3) == 'ocx'
              "
            >
              <use xlink:href="#iconword"></use>
            </svg>
            <svg
              class="icon fl"
              aria-hidden="true"
              v-if="
                item.file_name.substring(item.file_name.length - 3) == 'lsx'
              "
            >
              <use xlink:href="#iconexcel"></use>
            </svg>
            <svg
              class="icon fl"
              aria-hidden="true"
              v-if="
                item.file_name.substring(item.file_name.length - 3) == 'png'
              "
            >
              <use xlink:href="#icontupian1"></use>
            </svg>
            <svg
              class="icon fl"
              aria-hidden="true"
              v-if="
                item.file_name.substring(item.file_name.length - 3) == 'jpg'
              "
            >
              <use xlink:href="#icontupian1"></use>
            </svg>
            <svg
              class="icon fl"
              aria-hidden="true"
              v-if="
                item.file_name.substring(item.file_name.length - 3) == 'exe'
              "
            >
              <use xlink:href="#iconweizhiwenjian"></use>
            </svg>
            <svg
              class="icon fl"
              aria-hidden="true"
              v-if="
                item.file_name.substring(item.file_name.length - 3) == 'mp4'
              "
            >
              <use xlink:href="#iconshipin1"></use>
            </svg>
            <svg
              class="icon fl"
              aria-hidden="true"
              v-if="
                item.file_name.substring(item.file_name.length - 3) == 'mp3'
              "
            >
              <use xlink:href="#iconshipin1"></use>
            </svg>
            <svg
              class="icon fl"
              aria-hidden="true"
              v-if="
                item.file_name.substring(item.file_name.length - 3) == 'wmv'
              "
            >
              <use xlink:href="#iconweizhiwenjian"></use>
            </svg>
          </div>
          <div>
            <p>{{ item.file_name }}</p>
            <p>
              <span>发布时间：{{ item.create_time }}</span
              ><span class="uploading">上传者：{{ item.upload_uname }}</span>
            </p>
          </div>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="button(1)">取 消</el-button>
        <el-button type="primary" @click="button(2)">确 定</el-button>
      </span>
      <pagination
        @pagenew="pagenew"
        :listconhttpnum="listconhttpnum"
      ></pagination>
    </el-dialog>
  </div>
</template>

<script>
import URL from "@/api/index.js";
import $ from "jquery";
import VueEvent from "@/model/VueEvent";
import axios from "axios";
import pagination from "@/components/resource/pagination";
export default {
  components: {
    pagination,
  },
  data() {
    return {
      title_list: "",
      fileList: [],
      fileact: {},
      addfiledata: {
        title_list_list: "",
        formatypearr_list: "",
        cptid: "",
        fileurl: "",
        token: "",
        name: "",
      },
      dialogFormVisible: false,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      formLabelWidth: "120px",
      // 搜索
      shows: "up",
      input: "",
      sort_name: { sort1: "最新上传", sort2: "最多下载", sort3: "评分最高" },
      // 类型
      type_name: { type1: "类型", type2: "格式" },
      devActive: 0,
      fmtActive: 0,
      resourlist: "",
      formatypearr: "",
      fixedcheck: false,

      dialogVisible: true,
      resActive: 0,
      // 库列表
      list: [
        { name: "云资源", id: 0, type: 1 },
        { name: "校本资源", id: 1, type: 2 },
        { name: "我的资源", id: 2, type: 3 },
      ],
      // 课件列表
      httpArr: {
        restype: "",
        format: "",
        cptid: "4tns8Km1",
        bookid: "",
        type: "",
        word: "",
        orderkey: "down",
        page: "",
        pagenum: "8",
      },
      arr: [],
      // 总长度
      listconhttpnum: "",
      listact: null,
      resourceAct: {},
    };
  },
  created() {
    this.httpArr.cptid = JSON.parse(localStorage.getItem("cptid"));
  },
  mounted() {
    this.listconhttp(this.httpArr);
    this.resourhttp();
    this.getformatype();
    this.get_oss_key();
    this.getresoursetype();
  },
  methods: {
    get_oss_key() {
      var that = this;
      axios
        .post("https://test.rujiaowang.net/api/resource/get_oss_key")
        .then((res) => {
          that.aliyunOssToken = res.data.result.osssign;
        });
    },
    //上传本地资料 确定
    handleAddfile() {
      if (
        !this.addfiledata.title_list_list ||
        !this.addfiledata.formatypearr_list
      ) {
        this.$message({
          message: "请先选择素材格式和类型",
        });
        return false;
      }
      if (this.fileList.length == 0) {
        this.$message({
          message: "请选择素材文件",
        });
        return false;
      }
      this.dialogFormVisible = false;
      axios
        .post("https://test.rujiaowang.net/api/resource/addfile", {
          token: JSON.parse(localStorage.getItem("loginInfo")).token,
          name: this.fileact,
          fileurl: this.addfiledata.fileurl,
          fmttype: this.addfiledata.formatypearr_list,
          chapter_id: this.httpArr.cptid,
          restype: this.addfiledata.title_list_list,
          type: "3",
        })
        .then((res) => {
          if (res.data.state == 0) {
            this.$message({
              type: "success",
              message: "上传成功",
            });
            this.handlechange({ id: 2, name: "我的资源", type: 3 });
          } else {
            this.$message({
              message: res.data.msg,
            });
          }
          this.$emit("upload", true);
          VueEvent.$emit("upload", true);
          // localStorage.removeItem('cptid');
        });
    },
    beforeUpload(file) {
      var last = file.name.lastIndexOf(".");
      var postfix = file.name.substring(last);
      if (
        postfix != ".jpg" &&
        postfix != ".bmp" &&
        postfix != ".gif" &&
        postfix != ".jpeg" &&
        postfix != ".xls" &&
        postfix != ".xlsx" &&
        postfix != ".ppt" &&
        postfix != ".txt" &&
        postfix != ".mp4" &&
        postfix != ".doc" &&
        postfix != ".docx" &&
        postfix != ".pptx" &&
        postfix != ".mp3" &&
        postfix != ".wma" &&
        postfix != ".wav" &&
        postfix != ".wmv" &&
        postfix != ".asf" &&
        postfix != ".swf" &&
        postfix != ".rar" &&
        postfix != ".zip" &&
        postfix != ".m4a" &&
        postfix != ".flv" &&
        postfix != ".avi" &&
        postfix != ".png" &&
        postfix != ".mmap" &&
        postfix != ".xmind" &&
        postfix != ".ggb" &&
        postfix != ".pdf"
      ) {
        this.$message({
          message: "请上传正确的文件格式",
        });
        return false;
      }
      // 限制大小
      // const isLt500k = file.size / 1024 / 1024 < 0.48;
      // if (!isLt500k) {
      //   this.$message.error("上传图片大小不能超过 500k!");
      //   return false;
      // }
      var filename = file.name;
      var getSuffix = function (filename) {
        var pos = filename.lastIndexOf(".");

        var suffix = "";
        if (pos != -1) {
          suffix = filename.substring(pos); //文件后缀
        }
        return suffix;
      };

      filename =
        new Date().getTime() +
        Math.ceil(Math.random() * 10000) +
        getSuffix(filename);
      var _self = this;
      var formData = new FormData();
      //注意formData里append添加的键的大小写
      formData.append("key", _self.aliyunOssToken.dir + "eduyun/" + filename); //存储在oss的文件路径
      formData.append("OSSAccessKeyId", _self.aliyunOssToken.accessid); //accessKeyId
      formData.append("policy", _self.aliyunOssToken.policy); //policy
      formData.append("Signature", _self.aliyunOssToken.signature); //签名
      //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
      formData.append("callback", _self.aliyunOssToken.callback); //policy
      formData.append("file", file);
      formData.append("success_action_status", 200); //成功后返回的操作码
      var url = _self.aliyunOssToken.host;
      var fileUrl =
        _self.aliyunOssToken.host + "/" + _self.aliyunOssToken.dir + file.name;
      $.ajax({
        url: url,
        type: "POST",
        data: formData,
        // async: false,
        cache: false,
        contentType: false,
        processData: false,
        success: function (data) {
          // _self.addimg(data)//添加图片接口
          // VueEvent.$emit("addimg", data);
          // console.log(data.filename);
          // _self.$nextTick(() => {
          _self.addfiledata.fileurl = data.filename;
          // this.dialogFormVisible = true;
          // });
          // console.log(this.dialogFormVisible);
        },
        error: function (data) {},
      });
      if (file != null) {
        this.$emit("upload", false);
      }
    },
    handleChange(file, fileList) {
      // console.log(file, fileList);
      this.fileList = fileList;
      this.fileact = file.name;
    },
    choserestype(e) {
      var that = this;
      that.addfiledata.title_list_list = e;
    },
    chosefmttype(e) {
      var that = this;
      that.addfiledata.formatypearr_list = e;
    },
    // 本地上传 弹框
    handledialog() {
      this.fileList = [];
      // if (this.httpArr.cptid.length < 12) {
      //   this.$message({
      //     message: "请先选择具体的课程",
      //   });
      //   this.dialogFormVisible = false;
      // } else {
      this.dialogFormVisible = true;
      // }
    },
    handleClick(item, index) {
      if (item) {
        this.resourceAct = item;
        this.listact = index;
      }
    },
    convertKey(arr, key) {
      let newArr = [];
      arr.forEach((item, index) => {
        let newObj = {};
        for (var i = 0; i < key.length; i++) {
          newObj[key[i]] = item[Object.keys(item)[i]];
        }
        newArr.push(newObj);
      });
      return newArr;
    },
    // 搜索
    subchange(val) {
      this.httpArr.word = val;
      this.listconhttp(this.httpArr);
    },
    scShow() {
      this.shows = "up";
      this.httpArr.orderkey = this.shows;
      this.listconhttp(this.httpArr);
    },
    xzShow() {
      this.shows = "down";
      this.httpArr.orderkey = this.shows;
      this.listconhttp(this.httpArr);
    },
    pfShow() {
      this.shows = "score";
      this.httpArr.orderkey = this.shows;
      this.listconhttp(this.httpArr);
    },
    getresoursetype() {
      var that = this;
      axios
        .post("https://test.rujiaowang.net/api/resource/getresoursetype")
        .then((res) => {
          this.title_list = res.data.result.type_list.slice(1, 20);
        });
    },
    //类型
    resourhttp() {
      var that = this;
      this.$post(URL.getresoursetype).then((res) => {
        var resour_data = res.result.type_list;
        that.resourlist = resour_data;
        that.resourlist = that.convertKey(that.resourlist, [
          "type_id",
          "type_name",
        ]);
      });
    },
    //格式
    getformatype() {
      this.$post(URL.getformatype).then((res) => {
        this.formatypearr = res.result.type_list;
      });
    },
    // 类型
    restypechange(e) {
      this.httpArr.restype = e;
      this.listconhttp(this.httpArr);
      this.devActive = e;
      this.fixedcheck = false;
    },
    fmttype(e) {
      this.fmtActive = e;
      this.httpArr.format = e;
      this.listconhttp(this.httpArr);
    },

    // 弹框关闭
    handleClose1(done) {
      done();
      this.$emit("repository", this.dialogVisible);
    },
    button(res) {
      this.dialogVisible = false;
      this.$emit("repository", this.dialogVisible);
      if (res == 2) {
        this.$emit("resourceAct", this.resourceAct);
      }
    },

    //页码
    pagenew(val) {
      this.httpArr.page = val;
      this.listconhttp(this.httpArr);
    },
    // 库  type 选择
    handlechange(item) {
      // console.log(item);
      this.httpArr.page = 1;
      this.httpArr.type = item.type;
      this.listconhttp(this.httpArr);
      this.resActive = item.id;
    },

    item_xiangqing(item, index) {
      // console.log(item,index);
      var data = {
        fileid: this.arr[index].file_id,
      };
      this.$emit("book", item);
      this.$get(URL.fileView, data).then((res) => {});
      this.$router.push({
        name: "details",
        query: {
          data: this.arr[index],
        },
      });
      localStorage.setItem("item_xiangqing", JSON.stringify(this.arr[index]));
    },
    // 课件列表
    listconhttp(e) {
      var that = this;
      var data = {
        cptid: e.cptid,
        orderkey: e.orderkey,
        format: e.format,
        bookid: e.bookid,
        restype: e.restype,
        type: e.type,
        word: e.word,
        page: e.page,
        pagenum: e.pagenum,
      };
      this.$post(URL.selresource, data).then((res) => {
        that.arr = res.result.list;
        for (var i = 0; i < that.arr.length; i++) {
          that.arr[i].create_time = that.arr[i].create_time.slice(0, 10);
        }
        that.listconhttpnum = res.result.pagedata.listsum;
      });
    },
    // dianzan() {
    //   // console.log(11);
    // },
    // xiazai() {
    //   // console.log(2);
    // },
    // xinxi() {
    //   // console.log(3);
    // },
    fasong(res) {
      if (res == 1) {
        this.iscollect = false;
      } else {
        this.iscollect = true;
      }
      // console.log(4);
    },
  },
};
</script>

<style lang='less' scoped>
.box {
  line-height: 50px;
  margin-bottom: 8px;
  background-color: #e9f2f9;
  border-radius: 4px;
  .box_li {
    display: inline-block;
    padding: 0 30px;
    cursor: pointer;
    line-height: 50px;
    width: 60px;
    text-align: center;
  }
}
.posi {
  background-color: #f9f9f9;
  margin-bottom: 2px;
  border-radius: 4px;
}
.active {
  background-color: #3688fc;
  color: #ffffff;
  border-radius: 4px;
}
.st_list {
  li {
    border: 1px solid #f6f6f6;
    box-shadow: 0px 0px 10px 0px rgba(124, 122, 122, 0.08);
    padding: 4px 0;
    margin-bottom: 8px;
    div {
      display: inline-block;
      p {
        &:first-child {
          font-size: 16px;
        }
      }
      .uploading {
        margin-left: 15px;
      }
    }
  }
  li:hover {
    border: 1px solid #3688fc;
  }
  .listactive {
    border: 1px solid #3688fc;
  }
}
.zanwuicon {
  width: 300px;
  margin: 50px auto;
  span {
    text-align: center;
    display: block;
    color: #ccc;
  }
}
.icon {
  width: 80px;
  height: 50px;
}
/deep/ .el-divider--horizontal {
  margin: 0;
}
.type_list {
  width: 958px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
}
.type-content {
  display: flex;
  justify-content: safe;
}
.type-content li,
.list_span {
  float: left;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  color: #2f2f2f;
  padding: 0 5px;
  // line-height: 28px;
  border-radius: 5px;
  // margin-top: 18px;
  // margin-bottom: 10px;
  margin-left: 10px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.type-content li:hover {
  // background-color: #3688fc;
  color: #3688fc;
}
.type-content .active1 {
  // background-color: #3688fc;
  color: #3688fc;
}
.sort_content {
  height: 30px;
  margin-top: 30px;
  background-color: #fdfdfd;
  // box-shadow: 0px 2px 10px 0px rgba(33, 22, 19, 0.07);
  border-radius: 4px;
  margin-bottom: 20px;
  .search {
    li {
      float: left;
      width: 120px;
      text-align: center;
      line-height: 30px;
      // border-radius: 4px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      // color: #5e6062;
      cursor: pointer;
    }
  }
  .sort_active {
    // background-color: #3b8bfd;
    color: #2675e8;
    border-radius: 4px;
  }
  .ziyuan {
    // margin-top: 5px;
    margin-right: 7px;
    .zy_span {
      margin-right: 7px;
    }
    .zynumber {
      color: #3888fc;
    }
    .sousuo {
      display: inline-block;
    }
    .el-input {
      width: 100%;
    }
  }
}
.el-upload__tip {
  margin-left: 10px;
}
</style>
